import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentRoom5 } from "./ContentRoom5"
import { ContentRoom2 } from "./ContentRoom2"
import { Balloon } from "./Balloon"
import { Help } from "./Help"

import "./../assets/scss/Room5.scss";


export const Room5 = (props) => {

  const steps = {
    "b_intro" : ["intro", ""],
    "f_marge1" : ["", ""],
    "b_marge1a" : ["left", "follow"],
    "b_marge1b" : ["left", "follow"],
    "b_marge1c" : ["left", "close"],
    "f_visore" : ["", ""],
    "f_corriere" : ["", ""],
    "b_corriere" : ["image link", "close"],
    "f_podcast" : ["", ""],
    "risposta" : ["", ""],
    "b_exit" : ["exit", ""]
  };


  const handleLinkVisore = () => {
    window.open('https://goo.gl/maps/FYRGdk1Cppc6fSKR6', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("f_corriere"));
  }
  const handleLinkPodcast = () => {
    window.open('https://soundcloud.com/museoscienza/i-marziani-sono-nati-a-milano-giovanni-virginio-schiaparelli-e-lo-studio-di-marte-parte-2?in=museoscienza/sets/la-scoperta-del-cielo', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("risposta"));
  }

  React.useEffect(() => {
    if(props.step == Object.keys(steps).indexOf("risposta")) props.onNextHelp(1);
  }, [props.step]);

    return(
      <div className="room5">

        <div className="soffitto">
          <div className="cupola">
            <ContentRoom5 stringToRet="cupola" />
          </div>
        </div>

        <div className="parete"></div>

        <div className="pavimento"><div className="texture"></div></div>

        <div className="areaScrivania">
          <div className="piano">

            <button className={`visore button ${(props.step >= Object.keys(steps).indexOf("f_visore") &&  props.step <= Object.keys(steps).indexOf("risposta")) ? "active" : "unactive"}`}
                 onClick={props.step >= Object.keys(steps).indexOf("f_visore") &&  props.step <= Object.keys(steps).indexOf("risposta") ? handleLinkVisore : () => false } >
                {(props.step == Object.keys(steps).indexOf("f_visore")) &&
                  <CommonSvgContent stringToRet="click" />
                }
                {(props.step > Object.keys(steps).indexOf("f_visore") && props.step <= Object.keys(steps).indexOf("risposta")) &&
                  <div className="clickable" />
                }
                <CommonSvgContent stringToRet="visore" />
            </button>

             <button className={`corriere ${(props.step >= Object.keys(steps).indexOf("f_corriere")) ? "active" : "unactive"}`}
                      onClick={() => props.step >= Object.keys(steps).indexOf("f_corriere") ? props.onChangeStep(Object.keys(steps).indexOf("b_corriere")) : false } >
                {(props.step == Object.keys(steps).indexOf("f_corriere")) &&
                  <CommonSvgContent stringToRet="click" />
                }
                {(props.step > Object.keys(steps).indexOf("f_corriere") && props.step <= Object.keys(steps).indexOf("risposta")) &&
                  <div className="clickable" />
                }
                <img src={require('../assets/images/corriere.png')} alt="" />
             </button>

          </div>
          <div className="cornice" />
          <div className="gambadx" />
          <div className="gambasx" />
        </div>

        <button className={`areaRadio button ${(props.step >= Object.keys(steps).indexOf("f_podcast") &&  props.step <= Object.keys(steps).indexOf("risposta")) ? "active" : "unactive"}`}
             onClick={props.step >= Object.keys(steps).indexOf("f_podcast") &&  props.step <= Object.keys(steps).indexOf("risposta") ? handleLinkPodcast : () => false } >
            {(props.step == Object.keys(steps).indexOf("f_podcast")) &&
              <CommonSvgContent stringToRet="click" />
            }
            {(props.step > Object.keys(steps).indexOf("f_podcast") && props.step <= Object.keys(steps).indexOf("risposta")) &&
              <div className="clickable" />
            }

          <div className="mensolaRadio" />
          <ContentRoom5 stringToRet="radio" />
        </button>

        <div className="areaMappamondo">
          <div className="strutturaMappamondo">
            <ContentRoom5 stringToRet="mondo" />
          </div>
        </div>

        <div className="areaPlanet">
          <ContentRoom5 stringToRet="planet" />
        </div>

        <div className="satellite">
          <div className="filodx" />
          <div className="filosx" />
          <ContentRoom5 stringToRet="satellite" />
        </div>

        <div className="telescopio">
          <ContentRoom2 stringToRet="telescopio" />
        </div>

        <button
          className={`marge ${(props.step >= Object.keys(steps).indexOf("f_marge1")) ? "active" : "unactive"}`}
          onClick={() => props.step >= Object.keys(steps).indexOf("f_marge1") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1a")) : false } >
          {(props.step == Object.keys(steps).indexOf("f_marge1") ||
            props.step == Object.keys(steps).indexOf("f_marge2")) &&
            <CommonSvgContent stringToRet="click" />
          }
          {(props.step > Object.keys(steps).indexOf("f_marge1") && props.step <= Object.keys(steps).indexOf("risposta")) &&
            <div className="clickable" />
          }
          <CommonSvgContent stringToRet="marge" />
        </button>

        <div className={`areaTelefono ${(props.step == Object.keys(steps).indexOf("risposta")) ? "help3 ringing" : ""}`}>
          <div className="pianoUnder" />
          <div className="pianoOver">
            <button className={`telefono
                ${(props.step >= Object.keys(steps).indexOf("f_help")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_help") ? props.onChangeStep(Object.keys(steps).indexOf("b_help")) : false }>
              <CommonSvgContent stringToRet="telefono" />
              {(props.step == Object.keys(steps).indexOf("f_help")) &&
                <CommonSvgContent stringToRet="click" />
              }
            </button>

            <div className="helpsWrapper">
              <div className="helps">
              <button className="helpclick1 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 1) : false }>1</button>
              <button className="helpclick2 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 2) : false }>2</button>
              <button className="helpclick3 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 3) : false }>3</button>
              </div>
            </div>
          </div>
        </div>

        {(props.step == Object.keys(steps).indexOf("risposta")) &&
          <div className="risposta">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}

            <div className="rispostaCont">
              <form onSubmit={(e) => props.onSubmitAnswer(e, "room5", Object.keys(steps).indexOf("risposta"))}>
                <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                <input type="submit" value="OK" />
              </form>
              <p>19 caratteri senza spazi</p>
            </div>
          </div>
        }

        {(props.helpopen != 0) &&
          <Help room={props.room} clickon={`help${props.helpopen}`} onNextHelp={props.onNextHelp} />
        }

        {(Object.keys(steps).length > props.stepnow && Object.keys(steps)[props.stepnow].startsWith("b_")) &&
          <Balloon type={steps[Object.keys(steps)[props.stepnow]][0]} room={props.room} clickon={Object.keys(steps)[props.stepnow]} button={steps[Object.keys(steps)[props.stepnow]][1]} interaction={false} onChangeStep={props.onChangeStep} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
        }

      </div>
    )
}
